export default __webpack_public_path__ + "static/media/video_2.78dc59fc.mp4";